import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from "react-router-dom";
import request from '../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../helpers/PlantillaScreen';
import { Button } from '@mui/material';
import { LoaderScreen } from '../components/LoaderScreen';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ButtonBack } from '../PermisosUsuarios/GestioActividades/Util/ButtonBack';


export const CentroMonitoreoMaquinas = () => {

    const history = useHistory();
    const { jd_org_id } = useParams();
    const [data, setData] = useState([]);
    const [nombre, setNombre] = useState("");

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const onVerDetalle = (jd_machine_id) => {
        history.push(`/CentroMonitoreo/Detalle/${jd_machine_id}`);
    };

    useEffect(() => {
    setLoader({ ...loader, mostrar: true });

        Promise.all([
            request.get(`Maquina/PorOrganizacion/${jd_org_id}`),
            request.get(`Organizacion/Detalle/${jd_org_id}`)
        ])
            .then(([maquinas, organizacion]) => {
                setLoader({ ...loader, mostrar: false });
                setData(maquinas);
                setNombre(organizacion.nombre);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("LISTADO MÁQUINAS", JSON.stringify(error), "error");
            });

    }, [jd_org_id]);

    return (
        <PlantillaScreen
            titulo={`CENTRO DE MONITOREO - MÁQUINAS DE ${nombre}`}
            className_main={1}
            className={"centro-monitoreo-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className='cm-contenido'>

                <div className="cm-tabla cm-tabla-maquinas scroll">

                    <table className='cmt-container'>
                        <thead>
                            <tr>
                                <th>ID MÁQUINA</th>
                                <th>NOMBRE</th>
                                <th>MODELO</th>
                                <th>NÚM. SERIE</th>
                                <th>DETALLE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((maq) => (
                                <tr key={maq.jd_machine_id}>
                                    <td>{maq.jd_machine_id}</td>
                                    <td>{maq.nombre}</td>
                                    <td>{maq.modelo}</td>
                                    <td>{maq.numero_serie}</td>
                                    <td className='cm-ver-detalle'>
                                        <Button
                                            className='button-detalle'
                                            onClick={() => onVerDetalle(maq.jd_machine_id)}
                                        >
                                            <VisibilityIcon /> Ver Detalle
                                        </Button>
                                    </td>
                                </tr>
                            ))}   
                        </tbody>
                    </table>

                </div>

            </div>

            <ButtonBack path={'/CentroMonitoreo/Main'} ></ButtonBack>

        </PlantillaScreen>
    )
}